import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AnalyticsTopResultsActivityLoadAction } from '../../domains/analyticsTopResultsActivity/actions.types';
import { CampaignTopThreadsLoadFulfilledAction } from '../../domains/campaignTopThreads/actions.types';
import { EmployeesTopThreadsLoadFulfilledAction } from '../../domains/employeesTopThreads/actions.types';

import { AnalyticsTopResultsEntitiesLifecycle } from './types';

export type AnalyticsTopResultsAction =
  | AnalyticsTopResultsActivityLoadAction
  | EmployeesTopThreadsLoadFulfilledAction
  | CampaignTopThreadsLoadFulfilledAction;

const initialState: AnalyticsTopResultsEntitiesLifecycle = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<AnalyticsTopResultsEntitiesLifecycle, AnalyticsTopResultsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'EMPLOYEES_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'CAMPAIGN_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    default:
      return state;
  }
};

export default reducer;
